import React from "react";

const FeedbackCard = ({ review, name, rating }) => {
    const filledStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = 5 - filledStars - (hasHalfStar ? 1 : 0);

    return (
        <div className="feedback-card p-4 bg-transparent flex flex-col justify-between items-center h-64">
            {/* Review Text */}
            <p className="text-gray-800 italic text-center text-sm md:text-base mb-4">
                {review}
            </p>

            {/* Reviewer Name */}
            <div className="text-sm text-primary font-medium text-center mb-4">
                {`- ${name}`}
            </div>

            {/* Stars Section */}
            <div className="flex justify-center items-center space-x-2">
                {/* Full Stars */}
                {Array(filledStars).fill("⭐").map((star, index) => (
                    <span key={`filled-${index}`} className="text-yellow-500 text-xl md:text-2xl">
                        {star}
                    </span>
                ))}

                {/* Half Star */}
                {hasHalfStar && (
                    <span className="text-yellow-500 text-xl md:text-2xl">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            className="w-5 h-5 md:w-6 md:h-6 inline-block"
                        >
                            <path d="M12 2l3.09 6.26 6.91 1.01-5 4.87L18.18 22 12 18.27 5.82 22l1.18-6.86-5-4.87 6.91-1.01L12 2zm0 3.4l-1.74 3.53-.46.09-3.88.56 2.81 2.74-.76 3.84L12 14.91V5.4z" />
                        </svg>
                    </span>
                )}

                {/* Empty Stars */}
                {Array(emptyStars).fill("☆").map((star, index) => (
                    <span key={`empty-${index}`} className="text-gray-300 text-xl md:text-2xl">
                        {star}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default FeedbackCard;
